import { CreatedInterfaces } from 'interfaces';
import { useGetRequestWithoutIssuerHeader } from './utils/useGetRequestWithoutIssuerHeader';
import useGetRequestUpgrade from './utils/useGetRequestUpgrade';

const resource = 'issuer';

type UseGetIssuersProps = {
  manual?: boolean;
  issuerName: string;
};

const useGetIssuerInformation = ({ manual = false, issuerName }: UseGetIssuersProps) => {
  const {getData,
    getError,
    getLoading,
    executeGet } = useGetRequestUpgrade<CreatedInterfaces<typeof resource>>({
    path: `v1/issuer-information?issuer_name=${issuerName}`,
    manual
  });

  return {
    issuers: getData,
    isLoading: getLoading,
    isError: getError,
    executeGet
  };
};

export default useGetIssuerInformation;
